<template>
    <div class="sponsors"
         :style="styles"
    >
        <div>
            <h5 class="sponsor-title">
                {{ $t('registration.sponsors') }}
            </h5>
            <div class="sponsors-wrapper">
                <div v-for="(sponsor) in sponsors"
                     :key="`sponsor-${sponsor.id}`"
                     class="sponsor"
                     :class="{'disable-link' : disableLink(sponsor.button_url)}"
                >
                    <div class="sponsor-main-information-wrapper">
                        <a
                            :href="sponsor.button_url ? sponsor.button_url : 'javascript:void(0)'"
                            target="_blank"
                        >
                            <img v-if="sponsor.avatar.url"
                                 :src="sponsor.avatar.url"
                                 :alt="sponsor.title"
                            >
                            <v-icon v-else>{{ $t('event.sponsor') }}</v-icon>
                        </a>
                        <div v-if="sponsor.approval_number"
                             class="approval-number"
                        >
                            <span>{{ $t('event.approval_number') }}:</span> <span>{{ sponsor.approval_number }}</span>
                        </div>
                        <h6 v-if="sponsor.title">{{ sponsor.title }}</h6>
                        <p v-if="sponsor.short_description"
                           class="sponsor-short"
                        >
                            {{ sponsor.short_description }}
                        </p>
                        <a  v-if="sponsor.button_title"
                            :href="sponsor.button_url"
                            :style="{'background-color': sponsor.button_color}"
                            target="_blank"
                            class="v-btn sponsor-button"
                        >
                            {{ sponsor.button_title }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="sponsorsFooterLogo.url" class="footer-logo-container">
            <p class="sponsor-short">{{ $t('registration.sponsors_footer_text') }}</p>
            <img :src="sponsorsFooterLogo.url" />
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapState} from 'vuex';

    export default {
        name: 'Sponsors',
        computed: {
            ...mapGetters('project', ['sponsors', 'isInPreviewMode', 'pwaPrimaryColorRGB', 'sponsorsFooterLogo']),
            ...mapState('project', ['project']),
            styles() {
                return {
                    '--r': this.pwaPrimaryColorRGB.r,
                    '--g': this.pwaPrimaryColorRGB.g,
                    '--b': this.pwaPrimaryColorRGB.b,
                };
            },
        },
        methods: {
            disableLink(link) {
                return link === '' || this.isInPreviewMode;
            }
        }
    };
</script>

<style lang="scss" scoped>

$font-size-base-px: 16px;
@function rem-calc($px) {
     @return $px / $font-size-base-px * 1rem;
}

.sponsors {
  font-family: "Archivo", arial, helvetica, sans-serif;
  padding: 20px !important;
  display: grid;
  grid-template-rows: 1fr auto;
  min-height: 85vh;

  .sponsor-title {
    font-weight: 500;
    font-size: rem-calc(21px);
    margin-bottom: 20px;
    color: #3E3E3E;
  }
  .approval-number {
    font-size: rem-calc(12px);
    margin-top: -5px;
  }
  p {
    &.sponsor-short {
      font-size: rem-calc(13px);
      color: #3E3E3E;
      font-weight: normal;
    }
  }
  .sponsor-button {
    color: #FFF;
    padding: 8px 15px 6px 15px;
    text-transform: uppercase;
    font-size: 13px;
    font-weight: bold;
    letter-spacing: normal;
    margin-top: 8px;
    background: rgba(var(--r), var(--g), var(--b), 1);
    &:hover {
      filter: brightness(1.2);
    }
  }
  img {
    object-fit: contain;
    width: 100%;
    &:hover {
      filter: brightness(1.05);
    }
  }
  h6 {
    color: #000;
    font-size: rem-calc(19px) !important;
    margin: 5px 0;
  }
  .sponsor-main-information-wrapper {
    margin-bottom: 20px;
  }
}
.disable-link {
  a{
    pointer-events: none;
  }
}
.footer-logo-container {
  text-align: left;

  img {
    margin-top: 5px;
    object-fit: fill;
    width: 60%;
  }
}
</style>

<style lang="scss">
$font-size-base-px: 16px;
@function rem-calc($px) {
     @return $px / $font-size-base-px * 1rem;
}
.pwa {
    .sponsors {
    }
}
</style>
